import React from "react";
import { Col, Row } from "reactstrap";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";
import { useSelector } from "react-redux";
import SettingsAccountCard from "../component/SettingsAccountCard";
import SettingsAccountNewCard from "../component/SettingsAccountNewCard";
import SettingsAccountNewAccount from "../component/SettingsAccountNewAccount";
import SettingMenu from "../component/SettingMenu";

const SettingsAccount = () => {
  const depositAccounts = useSelector(
    (state) => state.user.user.data.bankingInfo.depositAccounts
  );
  const paymentCards = useSelector(
    (state) => state.user.user.data.bankingInfo.paymentCards
  );

  return (
    <div>
      <Header />
      <PageTitle />
      <div className="settings mb-80">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-md-4">
              <SettingMenu />
            </div>
            <div className="col-xl-9 col-md-8">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Linked Account or Card</h4>
                </div>
                <div className="card-body">
                  <div className="form">
                    <ul className="linked_account">
                      {depositAccounts.map((acc, index) => (
                        <SettingsAccountCard
                          key={`bank-${index}`}
                          id={acc.bankAccountId}
                          type={"Account"}
                          iconClass="fa fa-bank"
                          title={acc.bankName || "Bank Account"}
                          description={acc.currency.toUpperCase() || "Bank"}
                          maskedValue={
                            `${acc.branchNumber}${acc.transitNumber}${acc.accountNumber}` ||
                            "************XXXX"
                          }
                          verified={acc.verified}
                        />
                      ))}

                      {paymentCards.map((card, index) => (
                        <SettingsAccountCard
                          key={`card-${index}`}
                          id={card.id}
                          type={"Card"}
                          iconClass={`fa fa-cc-${(
                            card.brand || "credit"
                          ).toLowerCase()}`}
                          title={card.brand || "Payment Card"}
                          description={
                            `${card.expMonth}/${card.expYear}` || "Credit Card"
                          }
                          maskedValue={
                            `XXXX-XXXX-XXXX-${card.last4}` || "************XXXX"
                          }
                          verified={card.verified}
                        />
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Row className="align-items-center">
              <Col xs={6}>
                <SettingsAccountNewCard />
              </Col>
              <Col xs={6}>
                <SettingsAccountNewAccount />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SettingsAccount;
